import { Component, Inject, OnInit } from "@angular/core";
import {
  FormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'app-add-labour',
  templateUrl: './add-labour.component.html',
  styleUrls: ['./add-labour.component.scss']
})
export class AddLabourComponent implements OnInit {
  public otherChargesForm: UntypedFormGroup;
  public otherChargesColumns = [
    "Labour Name *",
    "Skill Type",
    "In Time",
    "Out Time",
    "Total Hrs",
    "Remark",
    "Action",
  ];
  viewType: any;
  editType: any;

  constructor(
    public dialogRef: MatDialogRef<AddLabourComponent>,
    public fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
    dialogRef.disableClose = true;
    this.buildForm();
  }

  buildForm() {
    this.otherChargesForm = this.fb.group({
      labourDetailsRequests: this.fb.array([]),
    });
    if (this.data?.data?.length) {
      this.data.data.map(this.onNewItemAdded);
      this.viewType = this.data.viewType;
      this.editType = this.data.editType;
    } else {
      this.onNewItemAdded();
      this.viewType = this.data?.viewType;
      this.editType = this.data?.editType;
    }
  }

  get labourDetailsRequests() {
    return (this.otherChargesForm.get("labourDetailsRequests") as FormArray)
      .controls;
  }

  onNewItemAdded = (data?) => {
    (this.otherChargesForm.get("labourDetailsRequests") as FormArray).push(
      this.fb.group({
        labourName: [data?.labourName || '', Validators.required],
        skillType: [data?.skillType || ''],
        inTime: [data?.inTime || ''],
        outTime: [data?.outTime || ''],
        totalHrs: [{ value: data?.totalHrs || 0, disabled: true }],
        remark: [data?.remark || ''],
      })
    );

    // If editing existing data that already has in/out time, calculate immediately
    if (data?.inTime && data?.outTime) {
      const index = (this.otherChargesForm.get("labourDetailsRequests") as FormArray).length - 1;
      this.calculateTotalHrs(index);
    }
  }

  calculateTotalHrs(index: number) {
    const group = this.labourDetailsRequests[index];
    const inTime = group.get('inTime').value;
    const outTime = group.get('outTime').value;

    if (inTime && outTime) {
      const [inH, inM] = inTime.split(':').map(Number);
      const [outH, outM] = outTime.split(':').map(Number);

      const inMinutes = inH * 60 + inM;
      let outMinutes = outH * 60 + outM;

      let diffMinutes = outMinutes - inMinutes;

      // handle overnight shift (out time next day)
      if (diffMinutes < 0) {
        diffMinutes += 24 * 60;
      }

      const totalHrs = parseFloat((diffMinutes / 60).toFixed(2));
      group.get('totalHrs').setValue(totalHrs);
    } else {
      group.get('totalHrs').setValue(0);
    }
  }

  onDeleteItem(index: number) {
    (this.otherChargesForm.get("labourDetailsRequests") as FormArray).removeAt(
      index
    );
  }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

  onSave() {
    this.dialogRef.close(this.otherChargesForm.get('labourDetailsRequests').getRawValue());
  }
}